export const UPDATE_TRAVELERS_CTA_TEXT = "Update travelers";
export const SELECT_ANOTHER_ACTIVITY_CTA_TEXT = "Select another activity";
export const TRY_AGAIN_CTA_TEXT = "Try again";

export const GENERIC_ERROR_TITLE = "There was an error.";
export const INVALID_PASSENGERS_TITLE = "Invalid passengers";
export const PASSENGER_VALIDATION_TITLE = "Passenger validation error";
export const UNABLE_TO_COMPLETE_BOOKING_TITLE =
  "Unable to complete your booking";
export const NO_AVAILABILITY_TITLE = "No availability";
export const MISSING_CONTACT_INFO_TITLE = "Missing contact information";
export const TOO_MANY_PASSENGERS_TITLE = "Too many passengers";
export const UPGRADE_REQUIRED_TITLE = "Upgrade is required";
export const BOOKING_FAILED_TITLE = "We were unable to process your booking.";

export const GENERIC_ERROR_SUBTITLE =
  "There was an error, reload the page or select another activity.";
export const GENERIC_ERROR_TRY_AGAIN_SUBTITLE =
  "There was an error, please try again or reload the page.";

// general
export const PRICE_INCREASE_TITLE = (difference: number) =>
  `The price for this activity has increased by $${difference.toFixed()}.`;
export const PRICE_DECREASE_TITLE = (difference: number) =>
  `You’re in luck! The price for this activity has decreased by $${difference.toFixed()}.`;
export const PRICE_CHANGE_SUBTITLE =
  "Sometimes activity prices can change unexpectedly. You can review the new activity price in the price total.";
